import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListComparatorsComponent } from './components/list-comparators/list-comparators.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ImportComparatorsComponent } from './components/import-comparators/import-comparators.component';
import { UploadComparatorsProcessingComponent } from './components/upload-comparators-processing/upload-comparators-processing.component';
import { DetailsComparatorsComponent } from './components/details-comparators/details-comparators.component';
import { FilterDetailsComparatorComponent } from './components/filter-details-comparator/filter-details-comparator.component';



@NgModule({
  declarations: [
    ListComparatorsComponent,
    ImportComparatorsComponent,
    UploadComparatorsProcessingComponent,
    DetailsComparatorsComponent,
    FilterDetailsComparatorComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class ComparatorModule { }
